import {
  Box,
  Grid,
  Button,
  Select,
  IconButton,
  Backdrop,
  ButtonGroup,
  CircularProgress,
  TextField,
  MenuItem,
  GridRowParams,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import Alert from "../../../components/ui/Alert";
import axios from "axios";
import { centralAdminUrls } from "../centralAdminUtils";
import SharedComponent from "../SharedComponent";
import {
  GetUserCountries,
  ExportSkuReplacementData,
  UpdateSKUSwitch,
  setState,
} from "../centralAdminSlice";
import { DataGridPro } from "@mui/x-data-grid-pro";
import SingleSelectSKU from "./SingleSelectSKU";
import MultiSelectCustomerProductCode from "./MultiSelectCustomerProductCode";
import MultiSelectSKUDescription from "./MultiSelectSKUDescription";
import MultiSelectNewSKU from "./MultiSelectNewSKU";
import MultiSelectReplaceOption from "./MultiSelectReplaceOption";
import CollapseSection from "../../../components/ui/CollapseSection";
import SearchIcon from "@mui/icons-material/Search";
import muiConfig from '../../../assets/MuiConfig.json'

export default function SKUSwitch() {
  const dispatch = useDispatch();
  const centralAdmin = useSelector((state) => state.centralAdmin);
  const {
    countries,
    selectedCountry,
    selectedCountryID,
    selectedClientProductCode,
    selectedSKUDescription,
    selectedNewSku,
    selectedReplaceOption,
  } = centralAdmin;

  const loginState = useSelector((store) => store.login);
  const { globalSelectedCountryName,globalSelectedCountryID,} = loginState      

  const [isLoading, setIsLoading] = useState(false);
  const [showOrHideExport, setShowOrHideExport] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [showButton, setShowButton] = useState(false);
  const [selectedRowID, setSelectedRowID] = useState([]);
  const [getSKUData, setGetSKUData] = useState([]);
  const [updatedSKUData, setUpdatedSKUData] = useState([]);
  const [getSKUbyCountry, setGetSKUbyCountry] = useState([]);
  let lstSKUSwthGrdFilteredData = [];

  const [validate, setValidate] = useState({
    countryValidated: false,
  });

  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: "",
  });

  const columns = [
    {
      field: "clientProductCode",
      headerName: "Old SKU Number",
      flex: 1.8,
      sortable: false,
      renderHeader: (params) => {
        return (
          <div>
            <strong>Old SKU Number</strong>
            <MultiSelectCustomerProductCode getSKUData={getSKUData} />
          </div>
        );
      },
    },
    {
      field: "productName",
      headerName: "Old SKU Description",
      flex: 3,
      sortable: false,
      renderHeader: (params) => {
        return (
          <div>
            <strong>Old SKU Description</strong>
            <MultiSelectSKUDescription getSKUData={getSKUData} />
          </div>
        );
      },
    },
    // {
    //   field: "countryName",
    //   headerName: "Country Name",
    //   flex: 1.5,
    //   sortable: false,
    //   renderHeader: (fixes) => (
    //     <strong sx={{ fontSize: 20 }}>{"Country Name"}</strong>
    //   ),
    // },
    {
      field: "isSwitch",
      headerName: "Replace?",
      flex: 1.5,
      renderCell: (params) => {
        return <SelectBox params={params} />;
      },
      renderHeader: (params) => {
        return (
          <div>
            <strong>Replace?</strong>
            <MultiSelectReplaceOption getSKUData={getSKUData} />
          </div>
        );
      },
    },

    {
      field: "switchedSKUName",
      headerName: "New SKU",
      flex: 3.5,
      sortable: false,
      renderHeader: (params) => {
        return (
          <div>
            <strong>New SKU </strong>
            <MultiSelectNewSKU getSKUData={getSKUData} />
          </div>
        );
      },
      renderCell: (params) => {
        return <TextBox params={params} />;
      },
    },
  ];

  useEffect(() => {
    if(globalSelectedCountryName !==null && globalSelectedCountryName !== "" ){
      dispatch(setState("selectedCountry", globalSelectedCountryName));
      dispatch(setState("selectedCountryID", globalSelectedCountryID));
      setValidate({
        ...validate,
        countryValidated: true,
      });

    }
    else{
        dispatch(setState("selectedCountry", ""));
        dispatch(setState("selectedCountryID", null));
    }
  }, []);  

  useEffect(() => {
    if (countries.length <= 0) {
      dispatch(GetUserCountries({ method: "Get" }));
    }
  }, [searchText]);

  useEffect(() => {
    filterGridDatabyReplace();
  }, [
    selectedClientProductCode,
    selectedSKUDescription,
    selectedNewSku,
    selectedReplaceOption,
  ]);

  function filterGridDatabyReplace() {
    lstSKUSwthGrdFilteredData = getSKUData;

    if (selectedReplaceOption != undefined && selectedReplaceOption.length > 0)
      lstSKUSwthGrdFilteredData = getSKUData.filter((x) =>
        selectedReplaceOption.includes(x.isSwitch)
      );

    if (
      selectedClientProductCode != undefined &&
      selectedClientProductCode.length > 0
    )
      lstSKUSwthGrdFilteredData = lstSKUSwthGrdFilteredData.filter((x1) =>
        selectedClientProductCode.includes(x1.clientProductCode)
      );

    if (
      selectedSKUDescription != undefined &&
      selectedSKUDescription.length > 0
    )
      lstSKUSwthGrdFilteredData = lstSKUSwthGrdFilteredData.filter((x1) =>
        selectedSKUDescription.includes(x1.productName)
      );

    if (selectedNewSku != undefined && selectedNewSku.length > 0)
      lstSKUSwthGrdFilteredData = lstSKUSwthGrdFilteredData.filter((x1) =>
        selectedNewSku.includes(x1.switchedSKUName)
      );

    setUpdatedSKUData(lstSKUSwthGrdFilteredData);
  }

  const handleSearchText = (e) => {
    const value = e.target.value;
    setSearchText(value);
  };

  const handleDisplay = () => {
    //  /ProductGroup/GetSKUSwitchSearch?CountryID=150&ProductName=ABACAV/LAMIVUD&SKUType=0
    //  /Admin/GetSKUbyCountry?countryId=150

    dispatch(setState("selectedClientProductCode", []));
    dispatch(setState("selectedNewSku", []));
    dispatch(setState("selectedReplaceOption", []));
    dispatch(setState("selectedSKUDescription", []));

    let obj = {
      countryID: selectedCountryID,
      productName: searchText,
    };

    if (!validate.countryValidated)
      displayAlert(true, "Please select a Country");
    else {
      GetSKUSwitchSearch(obj);
      GetSKUbyCountry(obj);
    }
  };

  const GetSKUSwitchSearch = (obj) => {
    const baseUrl =
      centralAdminUrls.getSKUSwitchSearch +
      "CountryID=" +
      obj.countryID +
      "&ProductName=" 
      // +
      // obj.productName +
      // "&SKUType=1";

    const autherization = localStorage.getItem("data");
    const data = JSON.parse(autherization);
    const token = data.token;

    setIsLoading(true);
    axios
      .get(baseUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        const data = response.data;
        const updatedData = updateInputSKUData(data);
        setUpdatedSKUData(updatedData);
        setGetSKUData(updatedData);

        if (updatedData.length > 0) {
          setShowOrHideExport(true);
        } else setShowOrHideExport(false);

        setIsLoading(false);
      });
  };

  function updateInputSKUData(data) {
    let updatedData = data.map((item) => {
      return {
        ...item,
        isCheckboxSelected: item.isSwitch,
      };
    });

    return updatedData;
  }

  const GetSKUbyCountry = (obj) => {
    const baseUrl =
      centralAdminUrls.getSKUbyCountry + "CountryID=" + obj.countryID;

    const autherization = localStorage.getItem("data");
    const data = JSON.parse(autherization);
    const token = data.token;

    setIsLoading(true);
    axios
      .get(baseUrl, {
        headers: {
          Authorization: "Bearer " + token,
        },
      })
      .then((response) => {
        const data = response.data;
        setGetSKUbyCountry(data);
        setIsLoading(false);
      });
  };

  async function exportDataAsFile(isPdf) {
    const obj = {
      isPdf,
      updatedSKUData,
    };
    setIsLoading(true);
    dispatch(ExportSkuReplacementData(obj)).then(() => setIsLoading(false));
  }

  const displayAlert = (showAlert, alertMessage) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: `${showAlert}`,
      alertMessage: `${alertMessage}`,
    });
  };

  useEffect(() => {
    //Check if any of the dropdown are false and then set alertDisplay to false
    const isAnyKeyValueFalse = (o) => !!Object.keys(o).find((k) => !o[k]);

    if (isAnyKeyValueFalse(validate)) {
      setAlert({ ...Alert, alertDisplay: false });
    }
  }, [validate]);

  const handleCountryChange = (e) => {
    const name = e.target.value;

    const countryID = countries.find(
      (country) => country.countryName === name
    ).countryID;

    if (name) {
      setValidate({
        ...validate,
        countryValidated: true,
      });
    }

    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));
  };

  const onRowsSelectionHandler = (ids) => {
    if (ids.length > 0) setShowButton(true);
    else setShowButton(false);

    setSelectedRowID(ids);
  };

  const handleSaveChanges = () => {
    let transformedArray = updatedSKUData.map((item) =>
      selectedRowID.includes(item.productID) ? item : null
    );

    let rowsToEdit = transformedArray.filter((item) => item !== null);
    const checkSave = rowsToEdit.filter(
      (item) => item.isSwitch == "No" || item.switchedSKUName == "Select SKU"
    );

    if (checkSave.length > 0) {
      displayAlert(true, "Please select New SKU");
    } else {
      const myrowsToEdit = rowsToEdit.map((item) =>
        item.switch === false ? { ...item, switch: true } : item
      );

      dispatch(UpdateSKUSwitch(myrowsToEdit)).then(() => handleDisplay());
    }
  };

  function SelectBox(params) {
    let switchValue = params.params.row.switch;
    let disabledMode = false;
    const [selectedItem, setSelectedItem] = useState(
      params.params.row.isSwitch
    );

    if (switchValue) {
      disabledMode = true;
    } else disabledMode = false;

    const handleReplaceOption = (event) => {
      setSelectedItem(event.target.value);
      disabledMode = false;
      let id = params.params.row.productID;

      const data = updatedSKUData.map((obj) =>
        obj.productID === id
          ? Object.assign(obj, {
              isSwitch: event.target.value,
            })
          : obj
      );

      setUpdatedSKUData(data);

      if (event.target.value == "No") {
        const updateSelectedText = updatedSKUData.map((obj) =>
          obj.userID === id
            ? Object.assign(obj, { switchedSKUName: "Select SKU" })
            : obj
        );

        setUpdatedSKUData(updateSelectedText);
      }
    };

    return (
      <Select
        sx={{ width: 150, height: "38px" }}
        value={selectedItem}
        onChange={handleReplaceOption}
        disabled={disabledMode}
      >
        <MenuItem key="1" value="Yes">
          YES
        </MenuItem>
        <MenuItem key="2" value="No">
          NO
        </MenuItem>
      </Select>
    );
  }

  function TextBox(params) {
    let id = params.params.row.productID;
    let isSwitch = params.params.row.isSwitch;
    let switchValue = params.params.row.switch;
    const [selectedSwitchedSKUName, setSwitchedSKUName] = useState(
      params.params.row.switchedSKUName
    );

    const handleText = (data) => {
      let selectedSwitchedskuid = "";
      var getSelectedSKUID = [
        getSKUbyCountry.filter((item) =>
          item.name === data ? (selectedSwitchedskuid = item.id) : null
        ),
      ];

      setSwitchedSKUName(data);

      const updatedData = updatedSKUData.map((obj) =>
        obj.productID === id
          ? Object.assign(obj, {
              switchedSKUName: data,
              switchedskuid: selectedSwitchedskuid,
            })
          : obj
      );

      setUpdatedSKUData(updatedData);
    };

    let disabled = false;
    if (params.params.row.switchedSKUName != "Select SKU") disabled = true;
    if (isSwitch == "Yes" && switchValue == false) disabled = false;
    if (isSwitch == "No") return <></>;
    else {
      return (
        <SingleSelectSKU
          disabled={disabled}
          getSKUbyCountry={getSKUbyCountry}
          selectedSwitchedSKUName={selectedSwitchedSKUName}
          sendDataToParent={handleText}
        />
      );
    }
  }

  return (
    <CollapseSection title="List of SKUs">
      <br />
      {alert.alertDisplay && (
        <Alert message={alert.alertMessage} severity={alert.alertSeverity} />
      )}
      <Grid
        container
        columns={12}
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        pb={1}
      >
        <Grid item xs={6} sm={3} md={4} lg={2}>
          <TextField
            variant="outlined"
            label="Country"
            select={countries.length > 0 ? true : false}
            value={countries.length > 0 ? selectedCountry : ""}
            onChange={handleCountryChange}
            fullWidth
            size="small"
          >
            {countries.length > 0
              ? countries.map((country, index) => {
                  return (
                    <MenuItem
                      key={country.countryID}
                      value={country.countryName}
                    >
                      {country.countryName}
                    </MenuItem>
                  );
                })
              : null}
          </TextField>
        </Grid>

        <Grid item xs={6} sm={3} md={3} lg={4}>
          <Button 
          variant="contained"
          color="primary"
          startIcon={<SearchIcon />}          
          sx={{
            bgcolor: "darkred.light",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            mt: 1,
            mr: 2,
            "&:hover": {
              bgcolor: "darkred.main",
            },
          }}          
           onClick={handleDisplay}>
            Search
          </Button>
        </Grid>
        <Grid item xs={12} sm={6} md={5} lg={6}>
          {showOrHideExport && (
            <Box>
              <IconButton onClick={(e) => exportDataAsFile(false)}>
                <GridOnIcon sx={{ color: "green.main" }} />
              </IconButton>
              <IconButton onClick={(e) => exportDataAsFile(true)}>
                <PictureAsPdfIcon sx={{ color: "red.main" }} />
              </IconButton>
            </Box>
          )}
        </Grid>
      </Grid>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress />
      </Backdrop>
      <SharedComponent />

      <Box
        mt={2}
        sx={{
          width: "100%",
          display: getSKUData.length > 0 ? "block" : "none",
        }}
      >
        <DataGridPro
          style={{ maxHeight: "calc(100vh - 130px)" }}
          sx={{
            m: 2,
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "normal",
              lineHeight: "normal",
            },
            "& .MuiDataGrid-columnHeader": {
              position: "sticky",
              height: "100px",
            },
            "& .MuiDataGrid-columnHeaders": {
              maxHeight: "268px !important",
            },
          }}
          disableColumnMenu
          rows={updatedSKUData || []}
          columns={columns}
          getRowId={(row) => row?.productID}
          onRowSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
          initialState={{
            pagination: { paginationModel: { pageSize:20, page:0 }}
          }}
          pagination
          pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]}
          checkboxSelection
          disableRowSelectionOnClick
          isRowSelectable={(params) => params.row.isCheckboxSelected === "No"}
        />
      </Box>

      <Box my={2} />
      <Grid
        container
        columns={12}
        justifyContent="flex-end"
        alignItems="right"
        my={2}
      >
        <ButtonGroup variant="text" aria-label="Basic button group">
          {showButton && (
            <Button 
            sx={{
              bgcolor: "darkred.light",
              color: "white.main",
              textTransform: "none",
              fontWeight: "bold",
              mt: 1,
              mr: 2,
              "&:hover": {
                bgcolor: "darkred.main",
              },
            }}            
            onClick={handleSaveChanges}> Save changes</Button>
          )}
        </ButtonGroup>
      </Grid>
    </CollapseSection>
  );
}
